import { gql } from "@apollo/client";

export const GET_SELLER_PROFILE = gql`
  query {
    getSellerProfile {
      success
      message
      data {
        seller_id
        email
        banner_pic
        logo_pic
        sid
        created_at
        updated_at
        contact_number
        company_locality
        shop_title
        company_description
        return_policy
        shipping_policy
        contract_doc
        patente_doc
        rne_doc
        cin_recto_doc
        cin_verso_doc
        rib_doc
        contract_doc_validation
        patente_doc_validation
        rne_doc_validation
        cin_recto_doc_validation
        cin_verso_doc_validation
        rib_doc_validation
      }
    }
  }
`;
